export const API_ENDPOINTS = {
  /**
   * Authentication endpoints
   */
  AUTH: {
    LOGIN_PRIVY: "/auth/privy",
    PROFILE: "/auth/profile",
    UPLOAD_AVATAR: "/auth/upload-avatar",
    LOGOUT: "/auth/logout",
  },

  /**
   * Home dashboard endpoints
   */
  HOME: {
    DASHBOARD: "/home/dashboard",
  },

  /**
   * Strava integration endpoints
   */
  STRAVA: {
    AUTHORIZE: "/strava/authorize",
    STATUS: "/strava/status",
    DISCONNECT: "/strava/disconnect",
    ANALYSIS: "/strava/analysis",
    ANALYZE: "/strava/analyze",
  },

  /**
   * Challenge endpoints
   */
  CHALLENGES: {
    LIST: "/challenges",
    CREATE: "/challenges",
    GET_BY_ID: (id: string) => `/challenges/${id}`,
    JOIN: (id: string) => `/challenges/${id}/join`,
    LEAVE: (id: string) => `/challenges/${id}/leave`,
    LEADERBOARD: (id: string) => `/challenges/${id}/leaderboard`,
    SUMMARY: (id: string) => `/challenges/${id}/summary`,
    // My Challenges endpoints
    MY_ACTIVE: "/challenges/my/active",
    MY_UPCOMING: "/challenges/my/upcoming",
    MY_COMPLETED: "/challenges/my/completed",
  },

  /**
   * Progress tracking endpoints
   */
  PROGRESS: {
    SYNC: (challengeId: string) => `/progress/sync/${challengeId}`,
    GET_STATS: (challengeId: string, walletAddress: string) =>
      `/progress/${challengeId}/${walletAddress}/stats`,
    GET_DAILY: (challengeId: string, walletAddress: string) =>
      `/progress/${challengeId}/${walletAddress}/daily`,
    GET_ENHANCED_STATS: (challengeId: string, walletAddress: string) =>
      `/progress/${challengeId}/${walletAddress}/enhanced-stats`,
  },

  /**
   * Notification endpoints (unauthenticated)
   */
  NOTIFICATIONS: {
    WELCOME: "/notifications/welcome",
  },

  /**
   * Coinbase Onramp endpoints
   */
  ONRAMP: {
    CREATE_URL: "/onramp/create-url",
    TRANSACTIONS: "/onramp/transactions",
    STATUS: "/onramp/status",
    PENDING_STATUS: "/onramp/pending-status",
  },

  /**
   * Coinbase Offramp endpoints
   */
  OFFRAMP: {
    CREATE_URL: "/offramp/create-url",
    TRANSACTION_STATUS: "/offramp/transaction-status",
    TRANSACTIONS: "/offramp/transactions",
    STATUS: "/offramp/status",
    PENDING_STATUS: "/offramp/pending-status",
  },

  /**
   * Feedback endpoints
   */
  FEEDBACK: {
    CREATE: "/feedback",
  },
} as const;
